import {put, race, select, take} from "redux-saga/effects";
import {enterQuestion, leaveQuestion} from "../../../questions/actions";
import {ActionType, getType} from "typesafe-actions";
import {randomInt} from "../../../../shared/utils/random";
import {ILevelMapAggregatedTile, ILevelMapTileProgress} from "../../types";
import {IApplicationState} from "../../../index";
import {incrementScoreMultiplier} from "../../actions";
import {loadScene} from "../../../routing/actions";
import {closeTutorial, showTutorial} from "../../../tutorial/actions";
import {TutorialKey} from "../../../tutorial/types";

function* tryShowTileTutorial(tile: ILevelMapAggregatedTile) {
    let tutorial: TutorialKey | void;

    if (tile.questionCount === 2) {
        tutorial = "gameplay.levelmap.doublequestiontutorial";
    }
    else if (tile.isBonusQuestion) {
        tutorial = "gameplay.levelmap.questioncontainingbonustutorial";
    }

    if (!tutorial)
        return;

    yield put(showTutorial.request({
        title: tutorial,
        closeOnTouch: true,
    }));

    yield race({
        success: take(closeTutorial),
        failure: take(showTutorial.failure),
    });
}

export function* handleQuestionTile(tile: ILevelMapAggregatedTile) {
    const {isExitFound, cardBonuses} = yield select(({ game, settings }: IApplicationState) => ({
        isExitFound: game.levelMapProgress[game.levelInProgress].isExitFound,
        cardBonuses: settings.miniGames.cardBonuses,
    }));

    let progress: Partial<ILevelMapTileProgress> = {};

    yield tryShowTileTutorial(tile);

    for (let questionId of tile.questions) {
        yield put(enterQuestion(questionId));
        yield put(loadScene.request('Question'));

        const { payload: questionProgress }: ActionType<typeof leaveQuestion> = yield take(getType(leaveQuestion));
        const {scoreMultiplier} = yield select(({ game }: IApplicationState) => ({
            scoreMultiplier: game.levelMapProgress[game.levelInProgress].scoreMultiplier,
        }));
        const questionScore = questionProgress.score * tile.questionCount;
        const score = questionProgress.isRight
            ? Math.floor(questionScore * scoreMultiplier)
            : 0;
        const additionalScore = questionProgress.isRight
            ? score - questionScore
            : 0;

        progress = {
            ...progress,
            isAnswered: true,
            isRight: questionProgress.isRight,
            score: (progress.score || 0) + score,
            additionalScore: (progress.additionalScore || 0) + additionalScore,
            bonus: tile.isBonusQuestion && questionProgress.isRight
                ? cardBonuses[randomInt(1, cardBonuses.length)]
                : undefined
        };

        if (!questionProgress.isRight)
            break;

        if (isExitFound) {
            yield put(incrementScoreMultiplier());
        }
    }

    return progress;
}